var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"HY5RO40XvZnJ0GO4sm36R"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';


Sentry.init({
  dsn: process.env.SENTRY_SHOP_DSN,
  sendDefaultPii: true,
  tags: { runTime: 'client' },
  tracesSampleRate: 0.1, // Adjust this value (0.0 to 1.0)
  environment: 'shop',
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  // For better performance monitoring with Next.js routing:
  // integrations: [
  //   new BrowserTracing({
  //     routingInstrumentation: Sentry.nextjsRouterInstrumentation,
  //   }),
  // ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
